import { useSnapshot } from 'valtio'
import React from 'react'
import { mapState } from '../store/mapState.ts'
import { faSignal } from '@fortawesome/free-solid-svg-icons/faSignal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
export const WebSocketIndicator: React.FC = () => {
    const webSocketConnected = (useSnapshot(mapState) as typeof mapState).webSocketConnected
    const indicator = {
        width: '1.5rem',
        height: '1.5rem',
        // borderRadius: '50%',
        color: webSocketConnected ? 'green' : 'red'
    }
    return (
        <div id={'websocket'} style={indicator}>
            <FontAwesomeIcon icon={faSignal}/>
        </div>
        )
}
